import { useEffect, useMemo, useState } from 'react';
import { getAdminInquiries, updateAdminInquiry } from '../../lib/api';
import type { AdminInquiry, InquiryStatus } from '../../lib/types';

export function InquiriesAdmin({ csrfToken }: { csrfToken: string }) {
  const [inquiries, setInquiries] = useState<AdminInquiry[]>([]);
  const [filter, setFilter] = useState<'all' | InquiryStatus>('all');
  const [notes, setNotes] = useState<Record<string, string>>({});
  const [error, setError] = useState('');
  const load = () => getAdminInquiries().then(setInquiries).catch((reason: Error) => setError(reason.message));
  useEffect(() => { void load(); }, []);
  const visible = useMemo(() => filter === 'all' ? inquiries : inquiries.filter((item) => item.status === filter), [filter, inquiries]);
  const newCount = inquiries.filter((item) => item.status === 'new').length;

  async function changeStatus(inquiry: AdminInquiry, status: InquiryStatus) {
    try { await updateAdminInquiry(inquiry.id, status, notes[inquiry.id] ?? '', csrfToken); setNotes((current) => ({ ...current, [inquiry.id]: '' })); await load(); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Unable to update inquiry.'); }
  }

  return <>
    <header className="admin-page-heading"><p className="admin-kicker">Leads</p><h1>Inquiries</h1><span className="admin-badge">{newCount} new</span></header>
    {error && <div role="alert" className="admin-error">{error}</div>}
    <label className="admin-filter">Status<select value={filter} onChange={(event) => setFilter(event.target.value as typeof filter)}>
      <option value="all">All</option>
      <option value="new">New</option>
      <option value="replied">Replied</option>
      <option value="closed">Closed</option>
    </select></label>
    {visible.length === 0 ? <p className="admin-empty">No inquiries match this view.</p> : <div className="inquiry-admin-list">
      {visible.map((inquiry) => <article key={inquiry.id}>
        <header>
          <div><strong>{inquiry.name}</strong><span>{inquiry.inquiryType}</span></div>
          <span className="admin-badge">{inquiry.status}</span>
        </header>
        <dl>
          <div><dt>Email</dt><dd><a href={`mailto:${inquiry.email}`}>{inquiry.email}</a></dd></div>
          <div><dt>Phone</dt><dd>{inquiry.phone || '—'}</dd></div>
          <div><dt>About</dt><dd>{inquiry.itemRef || '—'}</dd></div>
        </dl>
        <p>{inquiry.message}</p>
        <label>Private note<textarea value={notes[inquiry.id] ?? ''} onChange={(event) => setNotes((current) => ({ ...current, [inquiry.id]: event.target.value }))} /></label>
        <div className="admin-form-actions">
          <button type="button" onClick={() => changeStatus(inquiry, 'replied')}>Mark replied</button>
          <button type="button" onClick={() => changeStatus(inquiry, 'closed')}>Close</button>
        </div>
      </article>)}
    </div>}
  </>;
}
